import { shareHost } from "./brand";
import { toast } from "sonner";
import api, { API, imgUrl } from "./api";

const rr = (ctx, x, y, w, h, r) => { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); };
const loadImg = (src) => new Promise((res) => { const im = new Image(); im.crossOrigin = "anonymous"; im.onload = () => res(im); im.onerror = () => res(null); im.src = src; });
const ease = (t) => 1 - Math.pow(1 - Math.min(1, Math.max(0, t)), 3);

export const STORY_STYLES = {
  royal_gold: { bg: ["#1e3a8a", "#0f172a", "#3b0764"], frame: "#f5d67a", title: "#fde68a", glow: "rgba(251,191,36,.7)", tile: "#fff", digit: "#0f172a", rowHi: "rgba(251,191,36,.22)", rowHiStroke: "#fbbf24", rowStroke: "rgba(253,230,138,.35)", amount: "#6ee7b7", star: "255,255,255" },
  neon_night: { bg: ["#020617", "#0a0a1a", "#1a0033"], frame: "#22d3ee", title: "#f0abfc", glow: "rgba(34,211,238,.9)", tile: "#0f172a", digit: "#22d3ee", rowHi: "rgba(232,121,249,.25)", rowHiStroke: "#e879f9", rowStroke: "rgba(34,211,238,.4)", amount: "#a3e635", star: "34,211,238" },
  festival: { bg: ["#7f1d1d", "#b91c1c", "#f59e0b"], frame: "#fde047", title: "#fef08a", glow: "rgba(253,224,71,.8)", tile: "#fffbeb", digit: "#7f1d1d", rowHi: "rgba(253,224,71,.3)", rowHiStroke: "#fde047", rowStroke: "rgba(254,240,138,.45)", amount: "#fef08a", star: "253,224,71" },
};
export const STORY_STYLE_LABELS = { royal_gold: "Royal Gold", neon_night: "Neon Night", festival: "Festival" };

/* festival day (auto) > per-show category style > global admin style */
export function resolveStoryStyle(cfg, category) {
  if (!cfg) return { style: "royal_gold", reason: null };
  if (cfg.active_festival && cfg.festival_story_auto !== false) { const fs = cfg.active_festival.story_style; return { style: STORY_STYLES[fs] ? fs : "festival", reason: cfg.active_festival.name }; }
  const byCat = cfg.story_style_by_category?.[category];
  if (byCat && STORY_STYLES[byCat]) return { style: byCat, reason: category };
  return { style: STORY_STYLES[cfg.story_style] ? cfg.story_style : "royal_gold", reason: null };
}

export async function fetchStoryData(resultId) {
  const { data } = await api.get(`/results/${resultId}/top-winners`, { params: { limit: 5 } });
  return data;
}

/* Paint one frame of the 9:16 story. p = 0..1 animation progress (1 = final still). */
function paintFrame(ctx, W, H, d, assets, p) {
  const T = STORY_STYLES[assets.style] || STORY_STYLES.royal_gold;
  const bg = ctx.createLinearGradient(0, 0, 0, H); bg.addColorStop(0, T.bg[0]); bg.addColorStop(0.55, T.bg[1]); bg.addColorStop(1, T.bg[2]);
  ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
  assets.stars.forEach(([x, y, r, ph]) => { ctx.fillStyle = `rgba(${T.star},${0.15 + 0.5 * Math.abs(Math.sin(ph + p * 6))})`; ctx.beginPath(); ctx.arc(x * W, y * H, r, 0, Math.PI * 2); ctx.fill(); });
  if (assets.style === "neon_night") { ctx.shadowColor = T.frame; ctx.shadowBlur = 40; }
  ctx.strokeStyle = T.frame; ctx.lineWidth = 12; rr(ctx, 40, 40, W - 80, H - 80, 60); ctx.stroke(); ctx.shadowBlur = 0;
  if (assets.style === "festival") { for (let i = 0; i < 18; i++) { const fx = 60 + i * ((W - 120) / 17), sw = 0.7 + 0.3 * Math.sin(p * 8 + i); ctx.fillStyle = i % 2 ? "#fde047" : "#fb7185"; ctx.beginPath(); ctx.arc(fx, 70 + 22 * sw, 10, 0, Math.PI * 2); ctx.fill(); ctx.strokeStyle = "rgba(254,240,138,.6)"; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(fx, 46); ctx.lineTo(fx, 60 + 22 * sw); ctx.stroke(); } }
  // header
  const hp = ease(p * 4);
  ctx.globalAlpha = hp;
  if (assets.festival) {
    // festival greeting ribbon across the top
    const rp = ease(p * 3);
    ctx.save(); ctx.globalAlpha = rp;
    const rw = 760 * rp, rx = W / 2 - rw / 2, ry = 66;
    ctx.fillStyle = assets.style === "neon_night" ? "rgba(232,121,249,.92)" : assets.style === "festival" ? "#fde047" : "#f59e0b";
    ctx.shadowColor = T.glow; ctx.shadowBlur = 24; rr(ctx, rx, ry, rw, 62, 31); ctx.fill(); ctx.shadowBlur = 0;
    ctx.fillStyle = assets.style === "neon_night" ? "#1a0033" : "#7f1d1d"; ctx.textAlign = "center"; ctx.font = "900 34px sans-serif";
    ctx.save(); rr(ctx, rx, ry, rw, 62, 31); ctx.clip(); ctx.fillText(assets.festival.greeting, W / 2, ry + 44); ctx.restore();
    ctx.restore();
  }
  if (assets.logo) { ctx.save(); rr(ctx, W / 2 - 90, 130, 180, 180, 40); ctx.clip(); ctx.drawImage(assets.logo, W / 2 - 90, 130, 180, 180); ctx.restore(); }
  ctx.textAlign = "center"; ctx.fillStyle = T.title; ctx.font = "900 64px Cinzel, Georgia, serif"; ctx.fillText("ROYAL LAKSHMI", W / 2, 390);
  ctx.fillStyle = "rgba(255,255,255,.85)"; ctx.font = "700 40px sans-serif"; ctx.fillText(`${(d.game_name || "").toUpperCase()}  ·  ${d.draw_date || ""}${d.draw_time ? "  ·  " + d.draw_time : ""}`, W / 2, 450);
  ctx.globalAlpha = 1;
  // emblem
  if (assets.emblem) { const ep = ease((p - 0.08) * 3); ctx.save(); ctx.globalAlpha = ep; ctx.beginPath(); ctx.arc(W / 2, 640, 150 * (0.6 + 0.4 * ep), 0, Math.PI * 2); ctx.clip(); ctx.drawImage(assets.emblem, W / 2 - 150, 490, 300, 300); ctx.restore(); ctx.strokeStyle = T.title; ctx.lineWidth = 8; ctx.globalAlpha = ep; ctx.beginPath(); ctx.arc(W / 2, 640, 150, 0, Math.PI * 2); ctx.stroke(); ctx.globalAlpha = 1; }
  // result digits (each digit reels in)
  ctx.fillStyle = T.title; ctx.font = "800 44px sans-serif"; ctx.globalAlpha = ease((p - 0.2) * 3); ctx.fillText("OFFICIAL RESULT", W / 2, 880); ctx.globalAlpha = 1;
  const digits = String(d.winning_number || "").split("");
  const bw = 170, gap = 26, x0 = W / 2 - (digits.length * bw + (digits.length - 1) * gap) / 2;
  digits.forEach((ch, i) => {
    const dp = ease((p - 0.25 - i * 0.12) * 3.2);
    const x = x0 + i * (bw + gap);
    ctx.fillStyle = T.tile; ctx.shadowColor = T.glow; ctx.shadowBlur = 30 * dp; rr(ctx, x, 920, bw, 230, 30); ctx.fill(); ctx.shadowBlur = 0;
    ctx.strokeStyle = T.frame; ctx.lineWidth = 6; rr(ctx, x, 920, bw, 230, 30); ctx.stroke();
    ctx.save(); rr(ctx, x, 920, bw, 230, 30); ctx.clip();
    const shown = dp >= 1 ? ch : String((Math.floor(p * 40 + i * 3) % 10));
    ctx.fillStyle = dp >= 1 ? T.digit : "#94a3b8"; ctx.font = "900 190px 'JetBrains Mono', monospace"; ctx.fillText(shown, x + bw / 2, 1105 + (1 - dp) * 60);
    ctx.restore();
  });
  // winners
  const wp0 = 0.25 + digits.length * 0.12 + 0.1;
  ctx.globalAlpha = ease((p - wp0) * 3);
  ctx.fillStyle = T.title; ctx.font = "800 40px sans-serif"; ctx.fillText(d.total_winners ? `🏆 TOP WINNERS  ·  ${d.total_winners} winners · ₹${Number(d.total_paid || 0).toLocaleString("en-IN")}` : "🏆 NO WINNERS THIS SHOW — NEXT SHOW IS OPEN", W / 2, 1270);
  ctx.globalAlpha = 1;
  (d.top || []).slice(0, 4).forEach((w, i) => {
    const wp = ease((p - wp0 - 0.05 - i * 0.08) * 3.5);
    const y = 1310 + i * 110;
    ctx.globalAlpha = wp; const dx = (1 - wp) * 120;
    ctx.fillStyle = i === 0 ? T.rowHi : "rgba(255,255,255,.1)"; rr(ctx, 110 + dx, y, W - 220, 92, 24); ctx.fill();
    ctx.strokeStyle = i === 0 ? T.rowHiStroke : T.rowStroke; ctx.lineWidth = 3; rr(ctx, 110 + dx, y, W - 220, 92, 24); ctx.stroke();
    ctx.textAlign = "left"; ctx.fillStyle = "#fff"; ctx.font = "900 40px Outfit, sans-serif"; ctx.fillText(`${["🥇", "🥈", "🥉", "🏅"][i]}  ${w.name}  ${w.mobile}`, 140 + dx, y + 60);
    ctx.textAlign = "right"; ctx.fillStyle = T.amount; ctx.font = "900 44px Outfit, sans-serif"; ctx.fillText(`₹${Number(w.amount).toLocaleString("en-IN")}`, W - 140 + dx, y + 62);
    ctx.textAlign = "center"; ctx.globalAlpha = 1;
  });
  ctx.globalAlpha = ease((p - 0.85) * 6);
  ctx.fillStyle = "#fff"; ctx.font = "800 42px sans-serif"; ctx.fillText("Book the next show now  ·  " + shareHost(), W / 2, H - 120);
  ctx.globalAlpha = 1;
}

export async function fetchStoryConfig(d) {
  try {
    const cfg = await (await fetch(`${API}/config`)).json();
    const g = d?.game_id ? (await (await fetch(`${API}/games`)).json()).find((x) => x.id === d.game_id) : null;
    return { cfg, category: g?.category || null, ...resolveStoryStyle(cfg, g?.category) };
  } catch { return { cfg: null, category: null, style: "royal_gold", reason: null }; }
}

async function loadAssets(d, styleOverride) {
  let logo = null, emblem = null;
  const sc = await fetchStoryConfig(d);
  const style = STORY_STYLES[styleOverride] ? styleOverride : sc.style;
  const festival = sc.cfg?.active_festival?.greeting ? { greeting: sc.cfg.active_festival.greeting, name: sc.cfg.active_festival.name } : null;
  try { const cfg = sc.cfg; if (cfg?.app_logo) logo = await loadImg(imgUrl(cfg.app_logo)); const ci = sc.category && cfg?.category_images?.[sc.category]; if (ci) emblem = await loadImg(imgUrl(ci)); } catch {}
  const stars = Array.from({ length: 90 }, () => [Math.random(), Math.random(), 1 + Math.random() * 2.5, Math.random() * 6]);
  return { logo, emblem, stars, style, festival };
}

/** Final still (PNG data URL) */
export async function renderStoryImage(d, style) {
  const W = 1080, H = 1920, cv = document.createElement("canvas"); cv.width = W; cv.height = H;
  paintFrame(cv.getContext("2d"), W, H, d, await loadAssets(d, style), 1);
  return cv.toDataURL("image/png");
}

/** Small sample preview for admin style picker (no network) */
export function renderStoryPreview(style) {
  const W = 270, H = 480, cv = document.createElement("canvas"); cv.width = W; cv.height = H;
  const ctx = cv.getContext("2d"); ctx.scale(W / 1080, H / 1920);
  const sample = { game_name: "Goa Raja", draw_date: "Today", draw_time: "8:00 PM", winning_number: "4729", total_winners: 12, total_paid: 48000, top: [{ name: "Ravi", mobile: "98xxxx12", amount: 20000 }, { name: "Priya", mobile: "97xxxx45", amount: 12000 }] };
  const stars = Array.from({ length: 60 }, (_, i) => [(i * 0.618) % 1, (i * 0.377) % 1, 2, i]);
  paintFrame(ctx, 1080, 1920, sample, { logo: null, emblem: null, stars, style }, 1);
  return cv.toDataURL("image/png");
}

/** 5-second animated story (WebM via MediaRecorder) — resolves Blob or null if unsupported */
export async function renderStoryVideo(d, seconds = 5, style) {
  if (!window.MediaRecorder || !HTMLCanvasElement.prototype.captureStream) return null;
  const W = 720, H = 1280, cv = document.createElement("canvas"); cv.width = W; cv.height = H;
  const ctx = cv.getContext("2d"); ctx.scale(W / 1080, H / 1920);
  const assets = await loadAssets(d, style);
  const type = ["video/mp4;codecs=avc1", "video/webm;codecs=vp9", "video/webm"].find((t) => MediaRecorder.isTypeSupported(t));
  if (!type) return null;
  const stream = cv.captureStream(30);
  const rec = new MediaRecorder(stream, { mimeType: type, videoBitsPerSecond: 2500000 });
  const chunks = [];
  rec.ondataavailable = (e) => e.data.size && chunks.push(e.data);
  const done = new Promise((res) => { rec.onstop = () => res(new Blob(chunks, { type: type.split(";")[0] })); });
  rec.start(200);
  const t0 = performance.now();
  await new Promise((res) => { const tick = () => { const p = Math.min(1, (performance.now() - t0) / ((seconds - 1) * 1000)); paintFrame(ctx, 1080, 1920, d, assets, p); if (performance.now() - t0 < seconds * 1000) requestAnimationFrame(tick); else res(); }; tick(); });
  rec.stop();
  return done;
}

/** Share to WhatsApp Status: video if the device can share it, else image download + wa.me text */
export async function shareStory(d, style) {
  const text = `🏆 ROYAL LAKSHMI · ${d.game_name}\n${d.draw_date} ${d.draw_time || ""} official result: *${d.winning_number}*\n${d.total_winners ? `${d.total_winners} winners · ₹${d.total_paid}` : ""}\n\nPlay: ${window.location.origin}/play/${d.game_id}`;
  try {
    const video = await renderStoryVideo(d, 5, style).catch(() => null);
    if (video && navigator.canShare) {
      const vf = new File([video], `royal-laxmi-story-${d.winning_number}.${video.type.includes("mp4") ? "mp4" : "webm"}`, { type: video.type });
      if (navigator.canShare({ files: [vf] })) { await navigator.share({ files: [vf], text }); return "video"; }
    }
    const url = await renderStoryImage(d, style);
    const blob = await (await fetch(url)).blob();
    const f = new File([blob], `royal-laxmi-story-${d.winning_number}.png`, { type: "image/png" });
    if (navigator.canShare && navigator.canShare({ files: [f] })) { await navigator.share({ files: [f], text }); return "image"; }
    const a = document.createElement("a"); a.href = url; a.download = f.name; a.click();
    toast.success("Story saved — post it to your WhatsApp Status");
  } catch { /* fall through */ }
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
  return "text";
}
